import React, { useState, useEffect } from "react";
import Empsidebar from "../components/Empsidebar";
import Empheader from "../components/Empheader";
import Uppercase from "../../admin/components/Uppercase";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import "./Empshifts.css";
import {toast} from "react-toastify";

function Empshifts() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [role, setRole] = useState("");
  const [empId, setEmpId] = useState(""); // Store empId, not username!
  const [loginTime, setLoginTime] = useState(null);
  const [logoutTime, setLogoutTime] = useState(null);
  const [timeCounter, setTimeCounter] = useState(0);
  const [timerInterval, setTimerInterval] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [attendanceDate, setAttendanceDate] = useState(
    new Date().toLocaleDateString()
  );

  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      navigate("/login");
    } else {
      const decoded = jwtDecode(token);
      setUsername(decoded.email);
      setRole(decoded.role);

      if (decoded.role !== "employee") {
        navigate("/login");
      }
    }
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(
          ` https://api.easytaxexperts.com/api/userdetails/${username}`
        );
        setEmpId(response.data.empId);
      } catch (error) {
        console.error("Error fetching employee data", error);
      }
    };

    if (username) {
      fetchUserData();
    }
  }, [username]);

  const startTimer = () => {
    if (timerInterval) return;
    const loginTime = new Date().toLocaleTimeString();
    setLoginTime(loginTime);
    setTimerInterval(
      setInterval(() => {
        setTimeCounter((prevCounter) => prevCounter + 1);
      }, 1000)
    );
  };

  const stopTimer = async () => {
    if (!loginTime) {
      toast.error("Please log in before logging out.");
      return;
    }

    if (!empId) {
      console.error("EmpId is missing.");
      toast.error("Employee ID is missing. Unable to log attendance.");
      return;
    }

    clearInterval(timerInterval);
    setTimerInterval(null);
    const logoutTime = new Date().toLocaleTimeString();
    setLogoutTime(logoutTime);

    const workingHours = calculateWorkingHours(loginTime, logoutTime);

    try {
      const response = await axios.post(
        " https://api.easytaxexperts.com/api/empattendance",
        {
          empId,
          loginTime,
          logoutTime,
          date: attendanceDate,
          workingHours: workingHours.toFixed(2),
          remarks,
        }
      );
      console.log("Response:", response.data);
      toast.success("Attendance recorded successfully");
    } catch (error) {
      console.error("Error logging attendance:", error);
      toast.error("Error saving attendance. Please try again.");
    }
  };

  const calculateWorkingHours = (login, logout) => {
    const loginDateTime = new Date();
    const logoutDateTime = new Date();
    const [loginHours, loginMinutes, loginSeconds] = login.split(":");
    loginDateTime.setHours(parseInt(loginHours));
    loginDateTime.setMinutes(parseInt(loginMinutes));
    loginDateTime.setSeconds(parseInt(loginSeconds));

    const [logoutHours, logoutMinutes, logoutSeconds] = logout.split(":");
    logoutDateTime.setHours(parseInt(logoutHours));
    logoutDateTime.setMinutes(parseInt(logoutMinutes));
    logoutDateTime.setSeconds(parseInt(logoutSeconds));

    return Math.abs(logoutDateTime - loginDateTime) / 36e5; // Convert ms to hours
  };
  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Empheader openSidebar={openSidebar} />
        <Empsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container ">
            <div className="row justify-content-center">
              <div className="emp-content-left col-lg-8 col-md-10 col-sm-12">
                <div className="emp-info-card">
                  <h4>Employee Time Tracker</h4>
                  <p>Current Date: {attendanceDate}</p>
                  <div className="d-flex gap-2">
                    <button className="btn btn-success" onClick={startTimer}>
                      Login
                    </button>
                    <button className="btn btn-danger" onClick={stopTimer}>
                      Logout
                    </button>
                  </div>
                  <div className="mt-3">
                    <h6>Time Counter</h6>
                    <div className="text-success fw-bold fs-3">
                      {`${Math.floor(timeCounter / 3600)}:${Math.floor(
                        (timeCounter % 3600) / 60
                      )}:${timeCounter % 60}`}
                    </div>
                  </div>
                  <div className="mt-2">
                    <h6>
                      <strong>Login Time:</strong> {loginTime || "N/A"}
                    </h6>
                    <h6>
                      <strong>Logout Time:</strong> {logoutTime || "N/A"}
                    </h6>
                  </div>
                  <div className="mt-2">
                    <label htmlFor="remarks">Remarks:</label>
                    <input
                      type="text"
                      id="remarks"
                      className="form-control"
                      value={remarks}
                      onChange={(e) => setRemarks(e.target.value)}
                      placeholder="Optional"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Empshifts;
